import store from '@/store'

export function hasPermission(permission) {
  if (!permission) return true  // TODO: temporary condition until all permissions will be set
  const permissions = 'permissions' in permission ? permission.permissions : []
  const roles = 'roles' in permission ? permission.roles : []

  const profilePermissions = store.getters['ProfileModule/profile'].permissions
  const profileRole = store.getters['ProfileModule/profile'].role

  const hasAccessPermission =
    !permissions?.length ? false :
      !Array.isArray(permissions) ||
      permissions.some(permission => profilePermissions.includes(permission))
  const hasAccessRole = !Array.isArray(roles) || roles.includes(profileRole)

  return hasAccessPermission || hasAccessRole
}

export function canViewTrafficSourceFilter() {
  return hasPermission({
    permissions: ['traffic_source_view'],
    roles: ['ADMIN', 'TEAM_LEADER', 'AUDITOR'],
  })
}

export function canManageOfferPartnerTrafficSource() {
  return hasPermission({
    permissions: ['traffic_source_view', 'offer_partners_view', 'offer_partners_edit'],
    roles: ['ADMIN', 'TEAM_LEADER', 'AUDITOR'],
  })
}

// CPA-3558: backend lets MANAGER/PARTNER create/edit/delete Offer-Partners only with offer_partners_edit
export function canEditOfferPartner() {
  return hasPermission({
    permissions: ['offer_partners_edit'],
    roles: ['ADMIN', 'TEAM_LEADER'],
  })
}

// CPA-3444: retargeting/attribution columns, filters and blocks — API returns these fields only for ADMIN
export function canViewRetargeting() {
  return hasPermission({ roles: ['ADMIN'] })
}

// CPA-3587: ADMIN always; TEAM_LEADER / MANAGER only with the permission; PARTNER / AUDITOR never (backend answers 403 even if set)
function hasLeaderPermission(permission) {
  const { role, permissions } = store.getters['ProfileModule/profile']
  if (role === 'ADMIN') return true
  return ['TEAM_LEADER', 'MANAGER'].includes(role) && !!permissions?.includes(permission)
}

export function canViewRetargetingAttribution() {
  return hasLeaderPermission('retargeting_attribution_view')
}

export function canViewRetargetingAudience() {
  return hasLeaderPermission('retargeting_audience_view') || hasLeaderPermission('retargeting_audience_edit')
}

export function canEditRetargetingAudience() {
  return hasLeaderPermission('retargeting_audience_edit')
}

export function canBulkEditCpaSettings() {
  return hasLeaderPermission('cpa_settings_bulk_edit')
}

// Entity log families for TEAM_LEADER: permission → entity classes it unlocks
// (mirrors EntityLogRepository::LEADER_FAMILIES on backend). ADMIN sees all logs without them.
export const ENTITY_LOG_FAMILIES = {
  offer_log_view: ['offer'],
  partner_log_view: [
    'partner',
    'partner_info',
    'partner_manager',
    'partner_stream',
    'partner_group',
    'partner_affiliate',
    'partner_event_group',
    'spend_country_rule',
  ],
  offer_partner_log_view: [
    'offer_partner',
    'offer_partner_landing',
    'op_bl_deposit_history',
    'op_bl_registration_history',
    'op_bl_period_history',
    'op_cost_history',
    'op_country_requirement',
  ],
}

export const ENTITY_LOG_PERMISSIONS = Object.keys(ENTITY_LOG_FAMILIES)

// Root entity of each family — what the page sends as `entity` when a leader opens the log from the menu
export const ENTITY_LOG_ROOT_ENTITIES = ['offer', 'partner', 'offer_partner']

export function entityLogPermission(entity) {
  return ENTITY_LOG_PERMISSIONS.find(key => ENTITY_LOG_FAMILIES[key].includes(entity)) || null
}

export function canViewEntityLog(entity) {
  const permission = entityLogPermission(entity)
  return hasPermission({
    permissions: permission ? [permission] : [],
    roles: ['ADMIN'],
  })
}

export function canViewSpendImportLog() {
  const role = store.getters['ProfileModule/profile'].role
  return role !== 'TEAM_LEADER' || hasPermission({ permissions: ['spend_parse_log'] })
}
